












import { Component, Vue, Prop } from "vue-property-decorator";

import { Watcher } from "@/models";
import { getInitials } from "@/utils/names";

export interface WatcherBadgeModel extends Partial<Watcher> {
  label?: string;
}

@Component
export default class WatcherBadge extends Vue {
  @Prop()
  watcher!: WatcherBadgeModel;

  get initials() {
    return !this.watcher.label ? getInitials(this.watcher) : this.watcher.label;
  }
}
